import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { funnelStats, interestActivities, listInterests, updateInterest } from "./api";

export const useInterests = (filters: { status?: string; opportunityId?: string }) =>
  useQuery({ queryKey: ["interests", filters], queryFn: () => listInterests(filters) });

export const useFunnel = () => useQuery({ queryKey: ["funnel"], queryFn: funnelStats });

export const useInterestActivities = (id: string | null) =>
  useQuery({
    queryKey: ["interest-activities", id],
    queryFn: () => interestActivities(id as string),
    enabled: !!id,
  });

export function useUpdateInterest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      patch,
    }: {
      id: string;
      patch: { status?: string; internalNotes?: string | null; comment?: string | null };
    }) => updateInterest(id, patch),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ["interests"] });
      qc.invalidateQueries({ queryKey: ["funnel"] });
      qc.invalidateQueries({ queryKey: ["interest-activities", vars.id] });
    },
  });
}
